<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "ConsumersRoot",

  created() {
    this.getApiData();
  },

  methods: {
    async getApiData() {
      try {
        await this.$store.dispatch("consumer/getAllConsumerList", {
          page: 1
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    }
  }
};
</script>
